document.addEventListener('DOMContentLoaded', function () {
	const phoneElements = document.querySelectorAll('p[id^=\'click-collect-drawer_content-list__item--address-phone\']');
	phoneElements.forEach(function (phoneElement) {
		formatPhoneNumber(phoneElement);
	});
});

function formatPhoneNumber(phoneElement) {
	const phoneNumber = phoneElement.textContent;
	const countryCode = phoneNumber.substring(0, 3);
	const areaCode = phoneNumber.substring(3, 5);
	const firstPart = phoneNumber.substring(5, 9);
	const secondPart = phoneNumber.substring(9);

	const formattedPhoneNumber = `${countryCode} ${areaCode} ${firstPart}-${secondPart}`;
	phoneElement.textContent = formattedPhoneNumber;
}